import { type MutationHookOptions, useMutation } from "@apollo/client";
import { StartStreamMutation } from "../graphql/mutations";
import type {
  StartStreamMutationType,
  StartStreamMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useStartStreamMutation = (
  options?: MutationHookOptions<
    StartStreamMutationType,
    StartStreamMutationVariablesType
  >
) => {
  return useMutation<StartStreamMutationType, StartStreamMutationVariablesType>(
    StartStreamMutation,
    options
  );
};
